import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import Loader from "components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { deleteStudent, fetchAllCourseOfStudent, getSingleStudent, updateStudent } from "helpers/student_helper";
import profileLogo from "../../assets/images/profile_icon.png";
import { Modal } from "react-bootstrap";
import { FETCH_IMAGE } from "helpers/url_helper";
import { createEnrollment, deleteEnrollment } from "helpers/enrollment_helper";
import { fetchAllCourses } from "helpers/course_helper";
import { generatePresignedUrlForAccess } from "helpers/Content_helper";

const StudentDetails = (props) => {
    document.title = "Student Management | Student Details";
    const [spanDisplay, setSpanDisplay] = useState("none");

    const [loader, setLoader] = useState(false);

    const navigate = useNavigate();
    const params = useParams();

    const [studentDetails, setStudentDetails] = useState(null);
    const [selectedTab, setSelectedTab] = useState("Info");
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addCourseModal, setAddCourseModal] = useState(false);
    const [editCourse, setEditCourse] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [allCoursesOfStudent, setAllCourseOfStudent] = useState([]);
    const [studentAddressInfo, setStudentAddressInfo] = useState({
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
    });
    const breadcrumbItems = [
        { title: "Students", link: "#" },
        { title: "Student Details", link: "#" },
    ]
    useEffect(() => {           /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])



    useEffect(() => {
        props.setBreadcrumbItems('Student Details', breadcrumbItems)
    })

    const [organizationId, setOrganizationId] = useState(null);
    useEffect(() => {
        let a = JSON.parse(localStorage.getItem("authUser"));
        setOrganizationId(a.organizationId);

    }, []);

    const fetchStudentDetails = async () => {
        try {
            setLoader(true);
            const data = await getSingleStudent(params.id);
            setLoader(false);
            if (data?.success) {
                setStudentDetails(data?.result[0]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchStudentDetails();
    }, []);


    const handleUpdate = async () => {

        try {
            setLoader(true);
            const data = await updateStudent(studentDetails);
            if (data?.success) {
                toast.success(data?.message);
                setEditModal(false);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        console.log(studentDetails)
    }, [studentDetails])


    const handleDelete = async () => {
        try {
            setLoader(true);
            const data = await deleteStudent(params.id);
            if (data?.success) {
                toast.success(data?.message);
                navigate("/all-Students");
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
            setDeleteModal(false);
        }
    }


    useEffect(() => {
        fetchCourses();
    }, []);


    const fetchCourses = async () => {
        try {
            setLoader(true);
            const data = await fetchAllCourses();
            setLoader(false);
            if (data?.success) {
                updateThubmnail(data?.result, "all");
                // setAllCourses(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    const updateThubmnail = async (data, label) => {

        if (label === "all") {
            const updateData = await Promise.all(
                data.map(async (d) => {
                    // Ensure that `d.thumbnailName` exists before attempting to generate the URL
                    if (d?.thumbnailName) {
                        let name = d.thumbnailName;
                        let type = "image";
                        const response = await generatePresignedUrlForAccess({ name, type });

                        // Check if URL generation was successful and attach the URL to the course object
                        if (response.success) {
                            return {
                                ...d,
                                thumbnailUrl: response.presignedUrl, // Add the generated URL to the course object
                            };
                        } else {
                            console.error('Error generating pre-signed URL for', d.thumbnailName);
                            return d; // Return original course object if URL generation fails
                        }
                    }
                    return d; // Return the course as is if thumbnailName is missing
                })
            );

            setAllCourses(updateData);
        } else if (label === "student") {
            const updateData = await Promise.all(
                data.map(async (d) => {
                    // Ensure that `d.thumbnailName` exists before attempting to generate the URL
                    if (d?.courseDto?.thumbnailName) {
                        let name = d?.courseDto?.thumbnailName;
                        let type = "image";
                        const response = await generatePresignedUrlForAccess({ name, type });

                        // Check if URL generation was successful and attach the URL to the course object
                        if (response.success) {
                            return {
                                ...d,
                                courseDto: {
                                    ...d.courseDto,  // Ensure you preserve other properties in courseDto
                                    thumbnailUrl: response.presignedUrl, // Add the generated URL to the nested courseDto object
                                },
                            };
                        } else {
                            console.error('Error generating pre-signed URL for', d.thumbnailName);
                            return d; // Return original course object if URL generation fails
                        }
                    }
                    return d; // Return the course as is if thumbnailName is missing
                })
            );

            setAllCourseOfStudent(updateData);
        }


    }

    const handleAddCourseToStudent = async (id) => {
        try {
            setLoader(true);
            const data = await createEnrollment({
                progress: "0",
                status: "IN_PROGRESS",
                studentId: params.id,
                courseId: id
            });

            if (data?.success) {
                toast.success(data?.message);
                getAllCourseOfStudent();
            } else {
                toast.error(data?.message);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    const getAllCourseOfStudent = async () => {
        try {
            setLoader(true);
            const data = await fetchAllCourseOfStudent(params.id);
            if (data?.success) {
                updateThubmnail(data?.enrollResult, "student");
                // setAllCourseOfStudent(data?.enrollResult);

            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        getAllCourseOfStudent();
    }, []);

    const handleRemoveCourseToStudent = async (id) => {
        try {
            const data = await deleteEnrollment(id);
            if (data?.success) {
                toast.success(data?.message);
                getAllCourseOfStudent();
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>

                <Col>
                    <Card>
                        {/* <CardBody className="col-xl-6 col-lg-10 col-md-10 col-sm-12 col-xs-12"> */}
                        <CardBody className="" style={{ minHeight: "70vh", }}>

                            <div className="d-flex justify-content-between ">

                                {/* <CardTitle className="h4">Student Details</CardTitle> */}
                            </div>

                            <div className="d-flex">

                                <div className="">
                                    <img src={profileLogo} height={"100px"} alt="profile" />
                                </div>
                                <div className="m-3">
                                    <h3>
                                        <b>{studentDetails?.firstName}  {studentDetails?.lastName}</b>
                                    </h3>
                                </div>
                            </div>


                            <div className="d-flex mt-4" style={{ borderBottom: "1px solid gray" }}>
                                {/* Info Tab */}
                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Info" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Info")}
                                >
                                    <h5>Info</h5>
                                </div>

                                {/* Courses Tab */}
                                <div
                                    className=""
                                    style={{
                                        borderBottom: selectedTab === "Courses" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Courses")}
                                >
                                    <h5>Courses</h5>
                                </div>
                            </div>

                            {selectedTab === "Info" && (
                                <>

                                    <div className="mt-4">
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>First Name</h5>
                                                <p>{studentDetails?.firstName ? studentDetails?.firstName : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Last Name</h5>
                                                <p>{studentDetails?.lastName ? studentDetails?.lastName : "--"}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>Email</h5>
                                                <p>{studentDetails?.email ? studentDetails?.email : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Phone</h5>
                                                <p>{studentDetails?.mobile ? studentDetails?.mobile : "--"}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>DOB</h5>
                                                <p>{studentDetails?.dob ? studentDetails.dob : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Gender</h5>
                                                <p>{studentDetails?.gender ? studentDetails.gender : "--"}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>Address Line1</h5>
                                                <p>{studentDetails?.studentAddressInfo?.addressLine1 ? studentDetails.studentAddressInfo.addressLine1 : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Address Line2</h5>
                                                <p>{studentDetails?.studentAddressInfo?.addressLine2 ? studentDetails.studentAddressInfo.addressLine2 : "--"}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>City</h5>
                                                <p>{studentDetails?.studentAddressInfo?.city ? studentDetails.studentAddressInfo.city : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Address Line2</h5>
                                                <p>{studentDetails?.studentAddressInfo?.state ? studentDetails.studentAddressInfo.state : "--"}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <h5>Country</h5>
                                                <p>{studentDetails?.studentAddressInfo?.country ? studentDetails.studentAddressInfo.country : "--"}</p>
                                            </div>
                                            <div className="col-6">
                                                <h5>Postal Code</h5>
                                                <p>{studentDetails?.studentAddressInfo?.postalCode ? studentDetails.studentAddressInfo.postalCode : "--"}</p>
                                            </div>
                                        </div>

                                        {organizationId == 2 &&
                                            <>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <h5>Division</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.division || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Contractor Name</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.contractorName || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Contractor Token No</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.contractorTokenNo || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Aadhaar No</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.aadhaarNo || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Date of Service</h5>
                                                        <p>
                                                            {studentDetails?.tataStudentDetailsDto?.dateOfService
                                                                ? new Date(studentDetails.tataStudentDetailsDto.dateOfService).toLocaleDateString("en-IN")
                                                                : "--"}
                                                        </p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Last Attend Date</h5>
                                                        <p>
                                                            {studentDetails?.tataStudentDetailsDto?.lastAttendDate
                                                                ? new Date(studentDetails.tataStudentDetailsDto.lastAttendDate).toLocaleDateString("en-IN")
                                                                : "--"}
                                                        </p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Driver DL No</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.driverDlNo || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Driver Badge No</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.driverBadgeNo || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Nature of Work</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.natureOfWork || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Project</h5>
                                                        <p>{studentDetails?.tataStudentDetailsDto?.project || "--"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <h5>Licence Validity Date</h5>
                                                        <p>
                                                            {studentDetails?.tataStudentDetailsDto?.licenceValidityDate
                                                                ? new Date(studentDetails.tataStudentDetailsDto.licenceValidityDate).toLocaleDateString("en-IN")
                                                                : "--"}
                                                        </p>
                                                    </div>
                                                </div>

                                            </>
                                        }

                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}> <i className="mdi mdi-pencil "></i> Edit</button>
                                        <button className="px-3" style={{ cursor: "pointer", border: "none", backgroundColor: "red", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setDeleteModal(true)}> <i className="mdi mdi-delete "></i> Delete</button>
                                    </div>
                                </>
                            )}


                            {selectedTab === "Courses" && (
                                <>
                                    {organizationId != 2 &&
                                        <div className="d-flex justify-content-end mt-2">
                                     <Modal
                                     show={addCourseModal}
                                     size="lg"
                                     aria-labelledby="contained-modal-title-vcenter"
                                     centered
                                       >
                                       <Modal.Header >
                                            Add Courses
                                           </Modal.Header>
                                            <Modal.Body>
                                             <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
                                             {allCourses?.map((d, i) => (
                                             <>
                                               <div className="card me-5" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px", }} >
                                               <img className="card-img-top" src={d?.thumbnailUrl} alt="Card image cap" height={"50%"} />
                                               <div className="card-body" >
                                                    <h5 className="card-title">{d?.title}</h5>
                                        {/* <p className="card-text">{d?.description}</p> */}
                                                 <div className="d-flex justify-content-between">
                                                    <h5>Duration: </h5>
                                                   <p>{d?.duration} Hours</p>
                                              </div>

                                              <div className="d-flex justify-content-between">
                                                  <h5>Level: </h5>
                                                  <p>{d?.levelDto?.name}</p>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                <h5>Lnaguage: </h5>
                                                 <p>{d?.language}</p>
                                             </div>

                                             <div className="d-flex justify-content-between">
                                               <Button type="button" color="success" onClick={() => handleAddCourseToStudent(d?.id)} className="waves-effect waves-light">Add Course</Button>
                                             </div>

                                            </div>
                                           </div>
                                          </>
                                           ))}
                                       </div>

                                    </Modal.Body>
                                     <Modal.Footer>
                                        <Button type="button" color="primary" onClick={() => setAddCourseModal(false)} className="waves-effect waves-light">Close</Button>{" "}

                                     </Modal.Footer>
                                     </Modal>
                                            {/* <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}> <i className="mdi mdi-pencil "></i> Edit</button> */}
                                            {/* <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#58DB83", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setAddCourseModal(true)}> <i className="mdi mdi-plus "></i> Add Course</button> */}
                                        </div>
                                    }



                                    <div className="d-flex flex-row flex-wrap mt-3">
                                        {allCoursesOfStudent?.map((d, index) => (
                                            <>
                                                <div className="card me-5" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px", }} >

                                                    <img className="card-img-top" src={d?.courseDto?.thumbnailUrl} alt="Card image cap" height={"50%"} />
                                                    <div className="card-body" >
                                                        <h5 className="card-title">{d?.courseDto?.title}</h5>
                                                        {/* <p className="card-text">{d?.description}</p> */}
                                                        <div className="d-flex justify-content-between">
                                                            <h5>Progress: </h5>
                                                            <p>{d?.progress} %</p>
                                                        </div>

                                                        <div className="d-flex justify-content-between">
                                                            <h5>Status: </h5>
                                                            <p>{d?.status}</p>
                                                        </div>


                                                        <div className="d-flex justify-content-between">
                                                            <Button type="button" color="danger" onClick={() => handleRemoveCourseToStudent(d?.id)} className="waves-effect waves-light">Remove Course</Button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                </>
                            )}

                        </CardBody>
                    </Card>
                </Col>
            </Row>


            {/* Modal for edit student  */}
            <Modal
                show={editModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Student Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <div className="">
                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                First Name
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter First Name"
                                    value={studentDetails?.firstName} // bind to studentDetails.firstName
                                    maxLength="50"
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        firstName: e.target.value // update the firstName field
                                    }))}
                                />
                                {!studentDetails?.firstName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                Last Name
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Last Name"
                                    value={studentDetails?.lastName}
                                    maxLength="50"
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        lastName: e.target.value
                                    }))}
                                />
                                {!studentDetails?.lastName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>

                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                Email
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Email"
                                    value={studentDetails?.email}
                                    maxLength="100"
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        email: e.target.value
                                    }))}
                                />
                                {!studentDetails?.email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>

                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                Mobile
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="Enter Mobile Number"
                                    value={studentDetails?.mobile}
                                    maxLength="15"
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        mobile: e.target.value
                                    }))}
                                />
                                {!studentDetails?.mobile && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                DOB
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="date"
                                    id="dob-input"
                                    className="form-control"
                                    value={studentDetails?.dob || ""}
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        dob: e.target.value
                                    }))}
                                />
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <label
                                htmlFor="example-text-input"
                                className="col-md-2 col-form-label"
                            >
                                Gender
                            </label>
                            <div className="col-md-10">
                                <select
                                    id="gender-select"
                                    className="form-control"
                                    value={studentDetails?.gender || ""}
                                    onChange={(e) => setStudentDetails(prevDetails => ({
                                        ...prevDetails,
                                        gender: e.target.value
                                    }))}
                                >
                                    <option value="" disabled>Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                        </Row>

                    </div>





                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for delete student  */}
            <Modal
                show={deleteModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >

                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <h1> Are you sure want To delete this student</h1>
                    </div>







                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setDeleteModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Delete</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for add course  */}
            <Modal
                show={addCourseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    Add Courses
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
                        {allCourses?.map((d, i) => (
                            <>
                                <div className="card me-5" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px", }} >
                                    <img className="card-img-top" src={d?.thumbnailUrl} alt="Card image cap" height={"50%"} />
                                    <div className="card-body" >
                                        <h5 className="card-title">{d?.title}</h5>
                                        {/* <p className="card-text">{d?.description}</p> */}
                                        <div className="d-flex justify-content-between">
                                            <h5>Duration: </h5>
                                            <p>{d?.duration} Hours</p>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <h5>Level: </h5>
                                            <p>{d?.levelDto?.name}</p>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <h5>Lnaguage: </h5>
                                            <p>{d?.language}</p>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <Button type="button" color="success" onClick={() => handleAddCourseToStudent(d?.id)} className="waves-effect waves-light">Add Course</Button>
                                        </div>

                                    </div>
                                </div>
                            </>
                        ))}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddCourseModal(false)} className="waves-effect waves-light">Close</Button>{" "}

                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(StudentDetails);


